import React from "react";
import { Row, Col, Container } from "react-bootstrap";
import { TopMenu } from "../../shared";

function AboutUs() {
    return (
        <>
        <TopMenu/>
        
        <Col lg={12} className='inner-bg'>
            <Container className="middle-content">
                <div className="page-heading">
                    <img src='https://pmfby.amnex.co.in/pmfby/lms/lms-inner-banner.jpg' alt='Inner Banner - LMS' className='img-fluid pb-4' />
                    <h4 className="fw-bold mb-2">About Us</h4>
                    <ul className="my-topbreadcrum">
                        <li>
                            <a
                                href="/lms"
                            >Home</a>
                        </li>
                        &nbsp; / &nbsp;
                        <li>About Us</li>
                    </ul>
                </div>
                <Row className="m-4">
                    <Col lg={3}>
                        <img src="/lms/img/our-lms-info.svg" alt="PMFBY Logo" />
                    </Col>
                    <Col lg={9}>
                        <p>Ministry of Agriculture and Farmers Welfare (MoA&FW), Government of India (GoI) is implementing two major central sector flagship schemes - Pradhan Mantri Fasal Bima Yojana (PMFBY) and Modified Interest Subvention Scheme (MISS) on Kisan Credit Card (KCC). Prime objective of PMFBY is to provide simple and affordable crop insurance to protect farmers from crop loss due to unforeseen and non-preventable natural calamities.  MISS and KCC Scheme aims at providing need based and timely credit support to the farmers for their cultivation needs as well as allied activities in cost effective manner. </p>
                        <p>Welcome to this Learning Management System (LMS) - your gateway to comprehensive training and educational resources for farmers, Central and State Government officials, insurance intermediaries, agents, technical agencies, apex training and academic institutes and other stakeholders involved directly and indirectly in the implementation of PMFBY and KCC.</p>
                        <p>Our user-friendly platform is designed to empower you with the knowledge and skills needed to navigate the world of agriculture insurance and agricultural credit. With interactive courses, personalized learning paths, progress tracking, discussion forums, webinars, and access to expert resources, our LMS offers a transformative learning experience. </p>
                        <p>Explore our course catalog, embark on a journey of discovery, and gain the vast knowledge necessary to make informed decisions and contribute to the growth of the agricultural sector. 
Join us today and unlock your potential with the LMS on PMFBY & KCC.</p>
                    </Col>
                </Row>

            </Container>
        </Col>
        </>
    );
}

export default AboutUs;
